import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

//Import Icons
import Icon from '@ailibs/feather-react-ts';

//import component
import NotificationDropdown from '../TopbarDropdown/NotificationDropdown';
import ProfileMenu from '../TopbarDropdown/ProfileMenu';

// Reactstrap

//import images
import logoSvg from '../../assets/images/logo-sm.svg';

//redux
import { useDispatch, useSelector } from 'react-redux';
import { showRightSidebarAction } from 'src/rtk/features/layout/layoutSlice';

const Header = () => {
  const dispatch = useDispatch();
  const { showRightSidebar, profileInfo } = useSelector((state: any) => ({
    layoutMode: state.Layout.layoutMode,
    showRightSidebar: state.Layout.ShowRightSidebar,
    profileInfo: state.profile.data,
  }));

  /*** Sidebar menu icon and default menu set */
  function tToggle() {
    const body = document.body;

    if (window.innerWidth <= 992) {
      body.classList.toggle('sidebar-enable');
      return;
    }

    body.classList.remove('sidebar-enable');
    const isCollapsed = body.getAttribute('data-sidebar-size') === 'sm';
    body.setAttribute('data-sidebar-size', isCollapsed ? 'lg' : 'sm');
  }

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 992) {
        document.body.classList.remove('sidebar-enable');
      }
    };

    document.body.classList.remove('sidebar-enable');
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      document.body.classList.remove('sidebar-enable');
    };
  }, []);

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box">
              <Link to="/dashboard" className="logo logo-dark">
                <span className="logo-sm">
                  <img src={logoSvg} alt="" height="24" />
                </span>
                <span className="logo-lg">
                  <img src={logoSvg} alt="" height="24" />{' '}
                  <span className="logo-txt">BCPS</span>
                </span>
              </Link>

              <Link to="/dashboard" className="logo logo-light">
                <span className="logo-sm">
                  <img src={logoSvg} alt="" height="24" />
                </span>
                <span className="logo-lg">
                  <img src={logoSvg} alt="" height="24" />{' '}
                  <span className="logo-txt">BCPS</span>
                </span>
              </Link>
            </div>

            <button
              onClick={() => {
                tToggle();
              }}
              type="button"
              className="btn btn-sm px-3 font-size-16 header-item"
              id="vertical-menu-btn"
              aria-label="Toggle navigation menu"
            >
              <i className="fa fa-fw fa-bars"></i>
            </button>
          </div>
          <div className="d-flex">
            {profileInfo?.type === 'Trainee' && (
              <div className="d-flex align-items-center px-3 current-slot-info">
                <h6 className="mb-0">
                  Current Slot : {[profileInfo?.details?.current_session_and_supervisor_info?.exam_training_info?.training_type, profileInfo?.details?.current_session_and_supervisor_info?.exam_training_info?.name].filter(Boolean).join(' - ') || 'N/A'}
                </h6>
              </div>
            )}
            <NotificationDropdown />
            <div
              onClick={() => {
                dispatch(showRightSidebarAction(!showRightSidebar));
              }}
              className="dropdown d-inline-block"
            >
              {/* <button
                type="button"
                className="btn header-item noti-icon right-bar-toggle"
              >
                <Icon name="settings" className="icon-lg" />
              </button> */}
            </div>
            <ProfileMenu />
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default Header;
